import React from 'react';

import SvgIcon from '~/components/core/SvgIcon';
import type { IconProps } from '~/components/icons/types';

const FileArrowUpIcon: React.FC<IconProps> = ({ iconColor, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" disableStrokeColor iconColor={iconColor} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0306 7.7194l-5.25-5.25A0.75 0.75 0 0 0 14.25 2.25H5.25A1.5 1.5 0 0 0 3.75 3.75V20.25a1.5 1.5 0 0 0 1.5 1.5H18.75a1.5 1.5 0 0 0 1.5-1.5V8.25A0.75 0.75 0 0 0 20.0306 7.7194ZM15 4.8103 17.6897 7.5H15ZM18.75 20.25H5.25V3.75h8.25V8.25a0.75 0.75 0 0 0 0.75 0.75h4.5V20.25Zm-3.9694-7.2806a0.75 0.75 0 0 1-1.0613 1.0613L12.75 13.0603V17.25a0.75 0.75 0 0 1-1.5 0V13.0603l-0.9694 0.9703a0.75 0.75 0 0 1-1.0613-1.0613l2.25-2.25a0.75 0.75 0 0 1 1.0613 0Z"
      fill={iconColor}
    />
  </SvgIcon>
);

export default FileArrowUpIcon;
